import { Profile } from "app/helpers/globals";


export const trackgpsProfile: Profile = {
    key: 'trackgps',
    domains: ['tachoanalytics.trackgps.ro', 'tachoanalytics.tracktest.ro'],
    theme: 'trackgps',
    apiUrl: (domain: string) => {
        return `https://api.${domain}/TachoSafe/`;
    },
    billingApiUrl: (domain: string) => {
        return `https://billing.${domain}/webProBilling`;
    },
    chartApiUrl: (domain: string) => {
        return `https://rszoft-report.${domain}/charts-generator-api/v0/`
    },
    // apiUrl: 'http://localhost:4200/TachoSafe/',
    // billingApiUrl: 'http://localhost:4200/TachoSafe/',
    // chartApiUrl: 'http://localhost:4200/TachoSafe/',
    i18nUrl: 'https://i18n.tacho5safe.com',
    i18nKey: 'tgpak_gvptiytqoe4ha4deonwdmzlonbrg23lhorsw23lbnaytg',
    disabledFeatures: ['devices', 'upload', 'subscription', 'connectedServices'],
    topBarButtons: {
        more: true,
        help: true,
        phone: false,
        rduAdmin: false,
        rduManager: true,
        t2sUpdater: false,
        tachosafeSite: false,
        changesInStructure: false,
    },
    language: {
        fallback: 'en',
        default: 'en',
    },
    showAds: false,
    websiteTitle: 'TachoAnalytics',
    staticFiles: {
        logoColor: 'assets/profiles/trackgps/newLogoColored.png',
        logoBlackAndWhite: 'assets/profiles/trackgps/newLogo.png',
        favicon: 'assets/profiles/trackgps/favicon.ico',
        backgroundImage: 'assets/profiles/trackgps/Login Page_Background_2400x1600.webp',
    },
    footerLinks: [
        // {
        //     name: 'Mobileye Türkiye Ausis, Çarpışma Önleyici Sistemler, Araç Takip',
        //     url: 'https://www.ausis.com.tr/'
        // }
    ],
    documentLinks: {
        termsOfService: 'https://trackgps.ro/termeni-conditii-tachoanalytics',
        cookieNotice: 'https://trackgps.ro/politica-cookies-tachoanalytics',
        privacyPolicy: 'https://trackgps.ro/confidentialitate-tachoanalytics',
    },
    noDriverVehicleBanner: 'noAds',
    disabledReports: ['web-pro-billing', 'vehicle-check'],
    forceShowScheduledReports: true,
    bffLogin: {
        url: 'https://tachoanalytics.trackgps.ro/bff/login?returnUrl=/sessions/bff-callback',
        userUrl: 'https://tachoanalytics.trackgps.ro/bff/user',
        changePasswordUrl: 'https://sso.trackgps.ro/account/changepassword',
    },
    ssoOverrides: {
        apiUrl: (domain: string) => {
            return `https://tachoanalytics.trackgps.ro/TachoSafe/`;
        },
        billingApiUrl: (domain: string) => {
            return `https://billing.${domain}/webProBilling`;
        },
        chartApiUrl: (domain: string) => {
            return `https://tachoanalytics.trackgps.ro/rszoft-report/charts-generator-api/v0/`;
        },
    },
};